import "../style/FooterSection.css";
import { FaArrowUp } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/NAV-ICON.png";

const FooterSection = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="footer-section">
        <div className="container footer-content">
          {/* Top Footer Layout */}
          <div className="footer-top">
            <div className="footer-left">
              <img src={logo} alt="MPRAR Logo" className="footer-logo" />
              <p className="footer-tagline">
                Simplifying workforce management for modern organizations.
              </p>
            </div>

            <div className="footer-links">
              <div className="footer-column">
                <h4>Product</h4>
                <Link to="/">Home</Link>
                <Link to="/features">Features</Link>
                <Link to="/pricing">Pricing</Link>
                <Link to="/contact">Contact</Link>
              </div>

              <div className="footer-column">
                <h4>Company</h4>
                {/* <a href="">About</a> */}
                <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>
                <Link to="/terms-of-service" target="_blank">Terms of Service</Link>
              </div>
            </div>
          </div>

          {/* Bottom Footer Layout */}
          <div className="footer-bottom">
            <p>© 2025 DAYDONE. All rights reserved.</p>
            <button className="back-to-top" onClick={scrollToTop}>
              Back to top <FaArrowUp className="arrow-icon" />
            </button>
          </div>
        </div>
        {/* <div className="mt-5 container">
          <img src={bannerImg} alt="Footer Banner" className="footer-banner" />
        </div> */}
      </footer>
    </>
  );
};

export default FooterSection;
